export default {
  share: {
    planCard: {
      viewPriceTable: '查看價格表',
      facilityDetails: '設施詳情',
      soldOut: '已售完',
      planAutoSwitchNotice:
        '{{date}}的「{{soldOutPlan}}」已售完。已為您選擇仍可購買的「{{selectedPlan}}」。'
    },
    activityCategory: {
      RAILWAY_TICKET: '鐵路車票',
      AIRPORT_TRANSPORTATION: '機場交通',
      SHINKANSEN: '新幹線',
      EXPRESS_BUS: '高速巴士',
      BUS_TOUR: '巴士遊',
      CRUISES: '遊船巡航・渡輪',
      RENTAL_CAR: '租車',
      CHARTER: '私人包團（含包車）',
      ATTRACTION: '設施門票',
      THEME_PARK: '主題樂園',
      MUSEUM_GALLERY: '博物館・美術館',
      AQUARIUM_ZOO: '水族館・動物園',
      TEMPLES_SHINES: '寺宇・神社',
      TOWER_BUILDING: '高塔・觀景台',
      JAPANESE_RESTAURANT: '日式餐廳',
      WESTERN_RESTAURANT: '西式餐廳',
      CHINESE_RESTAURANT: '中式餐廳',
      OTHER_RESTAURANT: '其他餐廳',
      DESSERT_BEVERAGE: '甜點・飲料',
      SIGHTSEEING_TOUR: '觀光行程',
      MARINE_SPORTS: '水上活動',
      OUTDOOR_ACTIVITIES: '戶外活動',
      ONSEN: '溫泉',
      SPA_MASSAGE: 'SPA水療・按摩',
      JAPANESE_CULTURAL_EXPERIENCE: '日本文化體驗',
      JAPANESE_CRAFT_EXPERIENCE: '日本工藝體驗',
      JAPANESE_COOKING_EXPERIENCE: '日本料理體驗',
      OTHER_EXPERIENCE: '其他體驗',
      HOTEL: '飯店',
      RYOKAN: '日式旅館',
      VACATION_RENTAL: '民宿',
      BUNDLE: '套裝',
      PASS: 'PASS',
      OTHERS: '其他'
    },
    product: {
      planDateFallbackNotice:
        '您選擇的日期（{{selectedDate}}）已售罄。已為您切換至最近可購買的日期（{{displayDate}}）。請確認日期後再購買。',
      planAutoSwitchConfirmPlan: '已選方案：「{{planTitle}}」',
      planAutoSwitchConfirmQuestion: '確認以上內容嗎？',
      switchLanguageTitle: '更換語言'
    },
    priceTableDialog: {
      title: '價格表',
      dateFormat: '{{month}}月{{day}}日{{weekday}}',
      weekdays: {
        0: '週日',
        1: '週一',
        2: '週二',
        3: '週三',
        4: '週四',
        5: '週五',
        6: '週六'
      }
    },
    common: {
      account: '帳戶',
      myPage: '我的主頁',
      booking: '訂單記錄',
      logout: '退出登入',
      save: '儲存',
      colon: '：',
      multiply: '×',
      next: '下一步',
      return: '返回',
      toPay: '前往付款',
      update: '更新',
      search: '搜尋',
      delete: '刪除',
      space: ' ',
      comma: ',',
      titleSeparator: ' · ',
      add: '加購',
      change: '變更',
      confirm: '確認',
      cancel: '取消',
      searchPlaceholder: '搜尋...',
      tilde: '~',
      showMore: '更多',
      notification: '通知',
      withParentheses: '{{value1}}（{{value2}}）',
      withDashSeparated: '{{val1}} - {{val2}}',
      selectTime: '請選擇時間'
    },
    price: {
      primary: '<currency>{{currency}}</currency> <amount>{{amount}}</amount>',
      prefix: '<currency>{{currency}}</currency><amount>{{amount}}</amount>',
      suffix: '<amount>{{amount}}</amount><currency>{{currency}}</currency>',
      jpyWord: 'JPY',
      cnyWord: '元',
      jpySymbol: '¥'
    },
    footer: {
      terms: '使用條款',
      cert: '旅行業登録：東京都知事登録旅行業第2-8013号（リンクティビティ株式会社）',
      copyright: '{{year}} Copyright LINKTIVITY Inc.© All Rights Reserved.',
      recaptchaNotice:
        '本網站受 reCAPTCHA 保護，Google 的<PrivacyLink>隱私權政策</PrivacyLink>和<TermsLink>服務條款</TermsLink>適用。'
    },
    validation: {
      required: '{{field}}為必填項',
      invalid: '請輸入有效的{{field}}',
      password: '請輸入至少8個字元，包含大寫字母、小寫字母、符號和數字',
      imageType: '請選擇圖片檔案',
      fileSize: '請選擇小於{{size}}MB的檔案',
      range: '請輸入{{min}}到{{max}}之間的值',
      requiredSelect: '請選擇{{field}}選項',
      nameInvalid: '{{field}}包含非法字元',
      romajiOnly: '{{field}}僅能輸入羅馬字',
      emailNotMatch: '電郵地址不一致',
      emailAlreadyRegistered: '該電郵地址已註冊，請先通過登入按鈕進行登入。',
      ticketExpired: '購買時間不能晚於活動開始時間。'
    },
    firebase: {
      'auth/wrong-password': '帳戶名稱或密碼有誤。',
      'auth/user-not-found': '帳戶名稱或密碼有誤。',
      'auth/email-already-in-use': '該E-mail信箱已被註冊。',
      'auth/too-many-requests': '登入失敗超過有限次數，煩請重設密碼或稍後再試。'
    },
    apiErrors: {
      baseError: '發生錯誤。',
      clientError: '發送API請求時發生客戶端錯誤。',
      serverError: '伺服器無法完成該請求。',
      connectionError: '連接伺服器失敗，煩請檢查您的網路設定並重新嘗試。',
      requestError: 'API請求發生錯誤。',
      ARSError: {
        AFFILIATE_ID_REQUIRED:
          '操作失敗，請回到原會員專屬首頁後再次進入商品頁重新嘗試。',
        BOOKING_NOT_ENOUGH_ALLOTMENT:
          '非常抱歉，由於所選日期/時間之庫存數量不足，煩請選擇其他日期/時間預訂。',
        BOOKING_NO_AVAILABILITY:
          '非常抱歉，由於所選日期/時間之庫存數量不足，煩請選擇其他日期/時間預訂。',
        PERMISSION_DENIED: '非常抱歉，您無權訪問該資源。',
        NOT_FOUND: '查無此資源。',
        BOOKING_ALREADY_ISSUED: '恕無法取消已兌換或使用的訂單。',
        BOOKING_RESERVATION_OVERLIMIT: '預訂數量已超出上限。',
        BOOKING_RATE_LIMITED:
          '目前網站訪問人數眾多。\n造成您的不便，我們深感抱歉。\n敬請稍後透過下方的＜前往付款＞按鈕再次繼續操作。'
      },
      lottery: {
        LOTTERY_ALREADY_APPLIED:
          '此票券每人限購一次。您已完成申請，無法再次購買。'
      }
    },
    header: {
      openMenu: '開啟選單',
      closeMenu: '關閉選單'
    },
    login: {
      title: '登入／註冊',
      caption: '請選擇登入、註冊會員的方式。',
      appleLogin: 'Apple',
      googleLogin: 'Google',
      email: '郵箱地址',
      emailConfirm: '郵箱地址（確認）',
      password: '密碼',
      button: '登入',
      forgotPassword: '忘記密碼？',
      newAccount: '註冊',
      signInAgree: `※可使用第三方帳戶輕鬆登入、註冊會員。\n ※當您使用E-mail或第三方帳戶登入時，將視同您已同意相關 <TermsLink>{{terms}}</TermsLink> 與 <PrivacyLink>{{privacy}}</PrivacyLink> 。`,
      otpErrorMsg: '驗證碼輸入錯誤，請重新輸入。'
    },
    cart: {
      button: '購物車',
      empty: '購物車為空',
      addToCart: '添加到購物車',
      totalCount: '共 {{count}} 個商品',
      totalAmount: '合計',
      unavailable: '無法購買',
      deleteConfirm: '確定要刪除「{{activityName}}」嗎？',
      availabilityConfirmTitle: '確認購物車內容',
      availabilityConfirmContent:
        '購物車中包含已過銷售期或已售罄的商品。是否刪除這些商品並繼續下單？',
      availabilityConfirmProceed: '刪除並繼續',
      availabilityConfirmBack: '返回購物車'
    },
    payment: {
      ticket: '門票',
      plan: '套餐',
      dateTime: '日期時間',
      validityPeriod: '有效期',
      option: '附加商品',
      discount: '優惠',
      total: '合計（含稅）',
      details: '詳情',
      submit: '去下單',
      lotterySubmit: '申請抽選',
      lotteryBeforeOpen: '抽選未開始',
      lotteryClosed: '抽選已結束',
      numberOfPeople: '人數',
      totalWithTax: '合計 (含稅)',
      viewPlan: '查看套餐',
      warn: '不允許只購買{{unitName}}',
      optionRequiredTag: '必選',
      optionRequiredTip: '必須選擇附加商品',
      optionQuantityShortage: '尚需選擇 {{quantity}} 人份的附加商品',
      optionQuantityPartialShortage: '目前所選數量下，還差 {{quantity}} 人份',
      optionQuantityExcess: '附加商品的合計已超出方案數量 {{quantity}} 人份',
      planQuantityRequired: '請先選擇方案的參加人數'
    },
    password: {
      changePassword: '變更密碼',
      resetPassword: '重設密碼',
      sendResetEmail: '發送密碼重設郵件',
      sendResetEmailSuccess:
        '已將密碼重設連結發送至{{email}}，煩請確認並重新設定密碼。',
      oldPassword: '原密碼',
      newPassword: '新密碼',
      changePasswordSuccess: '密碼已成功變更。'
    },
    emailVerification: {
      title: '驗證郵件已發送',
      description: '驗證郵件已發送至{{email}}。',
      instruction: '請輸入郵件中的驗證碼完成註冊',
      resend: '重新發送',
      verify: '登入'
    },
    date: {
      sunday: '星期日',
      monday: '星期一',
      tuesday: '星期二',
      wednesday: '星期三',
      thursday: '星期四',
      friday: '星期五',
      saturday: '星期六'
    },
    profile: {
      title: '個人資料',
      firstName: '名',
      lastName: '姓',
      email: '電郵地址',
      confirmEmail: '電郵地址（確認）',
      password: '密碼',
      gender: '性別',
      birthday: '出生日期',
      birthdayYear: '年',
      birthdayYearPlaceholder: '請選擇',
      birthdayMonth: '月',
      birthdayDay: '日',
      birthdayYearOption: '{{value}}年',
      birthdayMonthOption: '{{value}}月',
      birthdayDayOption: '{{value}}日',
      country: '國家或地區',
      prefecture: '省份',
      postCode: '郵遞區號',
      postCodePlaceholder: '例：1234567（7位數字，不含連字號）',
      genderOptions: {
        male: '男性',
        female: '女性',
        other: '其他'
      },
      updateProfileSuccess: '個人資料更新成功',
      updateProfileFailed: '個人資料更新失敗, 請稍後重試',
      creditCardManagement: '信用卡管理',
      creditCardManagementGetErrMsg: '無法取得信用卡資訊。'
    },
    weeks: {
      sun: '日',
      mon: '一',
      tue: '二',
      wed: '三',
      thu: '四',
      fri: '五',
      sat: '六'
    },
    empty: {
      message: '沒有內容'
    },
    notFound: {
      subtitle: '此頁面暫不可用',
      returnHome: '返回首頁'
    },
    notFoundAuth: {
      subtitle: '此頁面暫不可用'
    },
    details: {
      title: '查看詳細'
    },
    orderConfirm: {
      title: '購買前確認事項（重要）',
      agree: '我已閱讀並同意以上內容'
    },
    invoice: {
      title: '開立收據',
      info: '收據資訊',
      name: '收據抬頭',
      remarks: '備註資訊',
      email: '接收收據的電子信箱',
      check:
        '每筆訂單原則上僅受理申請開立收據一次，如需再次開立收據，第二次起開立的收據皆將標注「補發」，敬請留意。',
      cancelFee: '取消手續費',
      cancelFeeAmount: '取消手續費金額',
      description: '品名／用途',
      content: '收據內容',
      confirm: '確認送出',
      success: '收據開立成功，請於您的信箱查收：{{email}}',
      price: '支付金額',
      refundAmount: '退款金額'
    }
  },
  faq: {
    title: '常見問題',
    bookingProcess: {
      title: '訂購流程',
      q1: '如何確認是否已完成訂購呢？',
      a1: `當您預訂完成，系統將發送訂單確認信至您所登錄的E-mail信箱，煩請查收信內所附訂單資訊及憑證。如收到附有「使用電子票」連結的信件，可點擊後直接使用。
  此外，您也可以點擊信內的「訂單詳情」以確認您的訂單資訊。`,
      q2: '沒有收到訂單確認信，該怎麼辦呢？',
      a2: `當您訂購「訂購即時確認」的商品，訂單將於約5分鐘內被自動確認並發送訂單確認信至您所登錄的E-mail信箱，若超過時間仍未收到訂單確認信，煩請檢查您的垃圾信件夾內是否有來自「@linktivity.co.jp」的信件。`,
      q3: '可以重新發行憑證嗎？',
      a3: `可以，請依以下步驟重新取得憑證：

1.登入您的帳號後，點選右上角「我的主頁」→「預訂信息」。
2.在該筆訂單中點擊「查看詳情」。
3.在「憑證資訊」欄即可查看票券內容，並可點選「發送憑證」重新寄送至指定的 E-mail。`
    },
    payments: {
      title: '付款',
      q1: '付款時出現了訂購失敗的訊息，該怎麼辦呢？',
      a1: `若發生此情形請先不要馬上重新訂購，請先於右上角的「帳戶」點擊「訂單資訊」，查看訂單一覽中是否有該訂單的紀錄，或煩請查收是否有收到訂單確認信。若皆未能找到訂單紀錄，則煩請稍待約5分鐘後再重新訂購。`,
      q2: '可以給我收據嗎？',
      a2: `抱歉目前無提供線上發行收據的服務，如需收據，煩請來信至客服信箱<helpcenter@linktivity.co.jp>，並請註明您的訂單編號、收據抬頭、款項名稱、金額等資訊。`,
      q3: '可使用哪些付款方式呢？',
      a3: `您可以使用信用卡進行付款（部分商品可使用Alipay、WeChat Pay付款）。恕無法使用便利商店付款或現金付款。`,
      q4: '什麼是3D驗證？',
      a4: `3D驗證為一種身份驗證服務，可防止信用卡被盜刷等非法使用，提高持卡人在進行信用卡線上消費時的安全性。
  使用支援3D驗證的信用卡進行付款時，會要求持卡人輸入一次性密碼進行身份驗證（驗證方式依信用卡公司而異）。`,
      q5: '該如何申請3D驗證？我不知道自己的信用卡是否支援3D驗證。',
      a5: `3D驗證可在刷卡前向信用卡公司申請完成註冊手續。
  如不清楚自己的信用卡是否支援3D驗證，請洽詢卡片背面的信用卡公司客服專線。`,
      q6: `我不知道自己的3D驗證密碼。我沒收到3D驗證一次性密碼。`,
      a6: `進行3D驗證時所需的密碼為事先向信用卡公司申請3D驗證時所設定的密碼，或是一次性密碼。
  如未收到一次性密碼，請檢查您的垃圾郵件。
  如不清楚密碼或是未收到一次性密碼，請洽詢卡片背面的信用卡公司客服專線。`,
      q7: `只能使用已註冊3D驗證的信用卡嗎？`,
      a7: `因近期信用卡盜刷事件劇增，日本經濟產業省宣布預計於2025年3月下旬全面履行電子商務本人認證（EMV 3-D驗證）義務化，恕本服務僅供已註冊3D驗證的信用卡可使用，敬請諒解。
  此外，於2023年3月發布的《信用卡安全指南【4.0版】》指出，將針對電子商務業者、信用卡公司（發卡公司、加盟店管理公司）及代理付款業者，全面履行「本人認證義務化及相關應對服務」。為符合上述準則，在新的預訂平台上必須使用提供3D驗證的結帳系統。`,
      q8: '我可以使用簽帳金融卡嗎？',
      a8: `您可以使用簽帳金融卡。`,
      q9: '3D驗證及額度均沒問題、在其他網站上也可正常使用的信用卡，為什麼會一直出現錯誤，無法付款？',
      a9: `如您的信用卡沒有問題卻無法付款，代表信用卡公司的付款審批系統可能發現有未經授權的使用紀錄，並可能已取消付款以保護您的信用卡。
  此情況與人為判斷不同，電腦會預測各種因素並根據該情況做出判斷，而造成在特定時間內無法付款的可能性。
  如遇上述問題，可改嘗試下述方法。
  ・使用不同的信用卡付款。
  ・過一段時間後再度嘗試使用該信用卡付款。
  ・聯絡您的信用卡公司，說明您想訂購的票券名稱和情況，要求信用卡公司訂正詐欺偵測和付款審批系統錯誤。`,
      q10: '我已收到信用卡公司的刷卡通知，但「我的帳戶」中沒有該訂單資訊，也沒收到訂購完成的電子郵件。',
      a10: `此情形可能為以下問題。
  ・電子信箱輸入錯誤（拼字錯誤等）。
  ・訂購時輸入的電子信箱與平時使用的的電子信箱不同。
  ・付款和訂購未完成（信用卡額度沒問題，但因某些錯誤導致付款和訂購未完成）
  如您有訂購時輸入的某個電子信箱印象，請嘗試使用該信箱登入「我的帳戶」。
  如仍無法成功登入，請將下述資訊與問題發送至LINKTIVITY客服中心<helpcenter@linktivity.co.jp>  ，由我們幫您查詢您的付款和訂購記錄。
  -訂購人姓名（英文拼音）：
  -活動參加日：
  -付款日期和時間（例：3/2 19:00）：
  -付款信用卡末3碼 ：
  -付款信用卡有効期限：
  -總金額：
  -訂購時可能輸入的電子信箱：`
    },
    changesAndCancellations: {
      title: '變更與取消',
      q1: '不小心訂錯了，該怎麼取消呢？',
      a1: `若您訂購的是可以取消的商品，請登入帳號後，依以下步驟取消：
  1.請於右上角的「帳戶」點擊「訂單資訊」。
  2.請於該訂單點擊「查看詳情」。
  3.請於「取消資訊」欄確認取消政策，並點擊「開始取消」，確認取消費用後請點擊「取消」即可取消訂單。`,
      q2: '取消訂單後何時可退款呢？',
      a2: `取消訂單後，退款時間依您的信用卡公司而異，如欲確認具體的退款時間，煩請向您的信用卡公司諮詢。`,
      q3: '可以變更訂單嗎？',
      a3: `煩請先取消原本的訂單，再重新訂購。由於是否可取消以及取消政策依商品而異，請先於商品頁下方的取消政策欄確認。`
    },
    accounts: {
      title: '帳戶',
      q1: '該如何註冊帳號呢？',
      a1: `您可於網站右上角的「登入」進行註冊，或於商品頁上訂購時亦可註冊。由於近日常發生註冊帳號時輸入了錯誤E-mail的情形，註冊帳號時煩請確認是否有輸入正確的E-mail信箱。
  此外，您亦可透過Apple或Google等帳號登入使用本服務。`,
      q2: '該如何登入呢？',
      a2: `請於訂購網站上的右上角點擊「登入」即可開始登入您的帳戶。`,
      q3: '忘記密碼了該怎麼辦呢？',
      a3: `請於登入頁面點擊「忘記密碼？」，依照頁面指示的步驟重新設定密碼。`
    },
    environment: {
      title: '網路環境',
      q1: '使用本網站時該使用什麼瀏覽器？',
      a1: `推薦使用以下瀏覽器：
  ・Firefox （最新版）
  ・Safari （最新版）
  ・Google Chrome （最新版）`,
      q2: '訂單確認信是使用什麼域名的信箱發送的呢？',
      a2: `本服務的信箱域名為「@linktivity.co.jp」，如有為預防垃圾郵件而設置電子郵件的網域限制，請於訂購前事先將「@linktivity.co.jp」加入許可清單。`
    },
    ticket: {
      title: '使用電子票',
      q1: '什麼是一次性密碼驗證？',
      a1: `當您的連結環境（裝置或瀏覽器等）發生變化時，為防止電子票遭第三者非法使用，本預訂系統將會發送一次性密碼（僅限一次有效的密碼）供您驗證。
  
  於不同的使用環境首次打開電子票時，系統將會發送一次性密碼以供驗證。
  為了確保使用當日可順利使用電子票，建議您可先於活動當日使用的行動裝置或瀏覽器上開啟電子票，查閱內容。
  
  例：
  第一次開啟電子票：A先生在自己的智慧型手機上開啟電子票時，不需進行一次性密碼驗證。
  第二次開啟電子票：A先生在家人的智慧型手機上開啟電子票時，因與第一次開啟電子票的行動裝置不同，將會出現要求完成一次性密碼驗證畫面。須完成驗證。
  此時輸入的電子信箱將會被登錄、固定於系統上。若第三次再以不同的行動裝置開啟電子票時，一次性密碼將會發送至該信箱。建議活動當日可先於信箱內確認是否可收到一次性密碼。`,
      q2: '我突然收到「您的連結環境已變化」訊息。該如何出示電子票？',
      a2: `當您的連結環境發生變化（使用與第一次開啟電子票的不同裝置或瀏覽器開啟電子票）時，須進行一次性密碼驗證。
  若出現上述訊息時，請先輸入您欲收到一次性密碼的電子信箱。※建議輸入可於活動當日現場查看一次性密碼的電子信箱，並確認該信箱是否可收到一次性密碼。
  當您收到郵件後，請輸入正文內的一次性密碼。如密碼無誤即驗證完成，可顯示您的電子票。`,
      q3: '我沒收到一次性密碼的電子郵件。',
      a3: `若超過時間仍未收到一次性密碼郵件，煩請檢查是否有在垃圾信件夾內。若您有限制網域，煩請將「@linktivity.co.jp」加至您的網域許可權。若已嘗試過上述方法仍未收到電子郵件，可能是您輸入的電子信箱有誤。煩請重新正確輸入電子信箱，或嘗試輸入其他的有效電子信箱。`,
      q4: '我可以更改一次性密碼的收件信箱嗎？',
      a4: `恕無法更改一次性密碼的收件信箱。
  一次性密碼一經驗證完成，之後的一次性密碼皆會發送至您登錄的電子信箱內。建議您登錄可於活動當日的行動裝置（當日攜帶的智慧型手機等）上查看電子票的電子信箱。`,
      q5: '我沒購買任何商品卻一直收到一次性密碼的驗證信，這是否為遭盜刷等非法使用？',
      a5: `若您一直收到一次性密碼的驗證信，可能為以下原因：
  ・您將電子票（憑證）轉發給其他同行遊客：
  若您的同行遊客在您開啟電子票、並完成一次性密碼驗證後開啟電子票時，因使用的裝置不同，系統將會向您發送一次性密碼驗證信。
  此時，因您的一次性密碼收件信箱（驗證一次性密碼時登錄的信箱）已被固定，每當您的同行遊客連接電子票時，系統將會依該次數發送一次性密碼驗證信。
  ・非法使用：若您未將電子票轉發給他人，則可能遭人盜用。請您深思熟慮，如有需要煩請重新訂購。`,
      q6: '我收到由不明信箱發送的一次性密碼。',
      a6: `若您收到來自不明信箱發送的一次性密碼，可能為以下原因：
  ・您將電子票（憑證）轉發給其他同行遊客：
  若您在您的同行遊客開啟電子票、並完成一次性密碼驗證後開啟電子票時，因使用的裝置不同，系統將會向您發送一次性密碼驗證信。
  此時，一次性密碼的收件信箱已被固定為該同行遊客的電子信箱（驗證一次性密碼時登錄的信箱），系統將自動發送密碼驗證信至該信箱。若遇此種情況，建議您可先詢問您的同行遊客。
  ・非法使用：若您未將電子票轉發給他人，則可能遭人盜用。請您深思熟慮，如有需要煩請重新訂購。`
    }
  },
  privacy: {
    lastUpdated: '最後更新時間：2022年3月18日',
    companyName: 'Linktivity Inc.',
    title: '隱私政策',
    personalInfoProtectionPolicy: '個人資料保護政策',
    personalInfoProtectionDescription:
      'Linktivity Inc.(以下稱「公司」)透過預訂網站LINKTIVITY等收集使用者的個人資料。公司認為保護使用者個人資料以使使用者能夠安心便利地進行預訂是極其重要的，公司遵守以下規定進行個人資料處理。',
    customerDataManager: '使用者數據管理員',
    companyAddress: '日本東京都千代田區內幸町2-1-6 日比谷公園前19樓',
    acquisition: '採集',
    acquisitionDescription:
      '公司僅在法律要求時獲得使用者同意後，為達到規定的使用目的而採集最少必要的個人資料。',
    usage: '使用',
    usageDescription:
      '公司僅將從使用者處採集的個人資料用於達到規定的使用目的。',
    storage: '存儲和保留',
    storageDescription:
      '公司謹慎關注系統安全，防止從使用者處採集的個人資料向外部洩露，進行個人資料的存儲和保留。',
    destruction: '銷毀和刪除',
    destructionDescription:
      '公司對不再需要使用的個人數據從不再需要的時點起毫不遲延地進行銷毀。',
    customerInquiry: '對使用者查詢的回應',
    customerInquiryDescription:
      '公司根據相關法律法規對使用者關於持有個人數據的使用目的通知請求、公開請求、更正/增加/刪除請求、使用中止/刪除請求以及第三方提供中止請求進行對應。',
    safetyMeasures: '安全管理措施',
    safetyMeasuresDescription:
      '公司透過教育確保所有與LINKTIVITY服務相關的員工理解個人資料的重要性，並採取必要且適當的措施進行個人資料保護。',
    tableOfContents: '目錄',
    policy1: {
      title: '公司採集的個人資料及使用目的',
      description:
        '公司為以下規定的使用目的採集和使用使用者的地址、姓名、出生日期、聯繫方式、電子郵件地址、護照號碼等個人資料。公司不在未獲使用者同意的情況下採集敏感個人資料。在採集使用者個人資料時，如個人資料的使用目的未公開，公司應向使用者通知或公開該採集的個人資料的使用目的。公司不在未獲父母同意的情況下採集13歲以下兒童的個人資料。在提供13歲以下兒童的個人資料時，公司將其視為已獲得父母同意，但如明確得知未獲同意，公司除了與父母聯繫及相關目的外，不使用該個人資料。',
      serviceUsage: {
        title: 'LINKTIVITY服務使用(會員註冊等)',
        description: '為使用LINKTIVITY服務，使用者個人資料在公司內部共享。',
        legalBasis: '為提供使用者要求的服務和功能而必需。'
      },
      ticketPurchase: {
        title: '車票購買申請',
        infoItems:
          '公司在處理來自產品提供商的車票購買申請時，採集使用者的姓名、支付資訊、護照號碼以及使用者的健康狀況相關資訊，包括健康狀態和病史。',
        purpose:
          '公司採集和使用使用者個人資料以驗證來自產品提供商的車票購買資格並處理車票及相關費用的支付。為實現這一目的，公司可向產品提供商、運輸公司、支付處理器和其他服務提供商(包括海外提供商)提供使用者個人資料。',
        legalBasis: '為提供使用者要求的服務和功能而必需。'
      },
      newsletter: {
        title: '發送新聞通訊(電子郵件雜誌等)及使用者通信',
        legalBasis: '基於使用者同意採集。'
      },
      advertising: {
        title: '透過社交媒體和廣告分發平台進行的廣告',
        legalBasis: '基於使用者同意採集。'
      },
      survey: {
        title: '問卷調查參與請求',
        legalBasis: '基於使用者同意採集，用於改進預訂網站、產品和服務。'
      },
      analysis: {
        title: '使用者資訊分析和管理',
        legalBasis:
          '為透過改進預訂網站、產品和服務來追求和保護使用者的正當利益而必需。'
      },
      fraudDetection: {
        title: '信用卡等欺詐使用檢測',
        legalBasis: '為確保使用者信用卡的安全並追求使用者的正當利益而必需。'
      }
    },
    policy2: {
      title: '個人數據的第三方提供',
      description: '除以下情況外，公司不向第三方提供從使用者處採集的個人數據。',
      case1:
        '當使用者透過本隱私政策或其他方式事先同意向第三方(包括產品提供商、海外旅行社、社交媒體提供商、廣告分發服務公司等)提供個人數據時。',
      case2: '當在達到規定使用目的所必需的範圍內將個人數據處理外包給第三方時。',
      case3: '當法律要求提供時。',
      case4: '當為保護人類生命、身體或財產而必需，且難以獲得使用者同意時。',
      case5:
        '當為改進公共衛生或促進兒童健全發展而特別必需，且難以獲得使用者同意時。',
      case6:
        '當政府或地方政府為實施法律規定的事務而需要合作，且獲得使用者同意可能會阻礙該事務的執行時。'
    },

    policy3: {
      title: '個人數據處理的委託',
      description:
        '當公司在達到規定使用目的所必需的範圍內將使用者個人數據處理委託給第三方時，公司對受委託的機構進行必要且適當的監督。如受委託的機構進一步委託給其他機構，公司直接或間接監督受委託的機構是否對再委託機構進行了必要且適當的監督。再委託機構的進一步委託情況也應如此。'
    },
    policy4: {
      title: 'Cookie資訊等採集',
      cookie: {
        title: 'Cookie',
        description1:
          'Cookie是存儲在使用者硬碟上包含有關使用者資訊的數據文件。公司不使用Cookie來識別個人。Cookie是會話Cookie，當使用者關閉瀏覽器時不會被保留。Cookie用於改進使用者服務、自訂網站、測量廣告效果等目的。',
        description2:
          '公司將Cookie作為統計數據進行分析，以識別使用者的興趣和關注點並加以利用。Cookie也用於防止未授權訪問。',
        description3:
          '使用者可根據偏好禁用Cookie，但這樣做會導致使用者無法在LINKTIVITY進行預訂。'
      },
      logFile: {
        title: '日誌文件',
        description1:
          '公司自動採集某些資訊並將其保存到日誌文件。這些特定資訊包括IP(網際網路協議)地址、瀏覽器類型、ISP(網際網路服務提供商)名稱、參考/退出頁面、作業系統及日期/時間戳。公司利用這些資訊監控未授權訪問、進行使用者趨勢分析、網站管理以及使用者在網站上的行為追蹤。',
        description2:
          '但是，公司以不能識別特定個人的方式使用這些資訊，不會將採集的資訊用於上述目的以外的任何目的。'
      },
      webBeacon: {
        title: '網路信標',
        description:
          '公司使用網路信標用於訪問分析和附屬計畫。公司不使用網路信標進行上述目的以外的任何目的或用於識別特定個人。'
      },
      statisticalAnalysis: {
        title: '統計分析',
        description1:
          '公司使用第三方訪問分析工具來識別哪些網站和服務受歡迎，並記錄使用者在LINKTIVITY網站內訪問的頁面和頁面歷史。',
        description2:
          '公司使用這些數據為在特定領域表示出興趣的使用者在LINKTIVITY內提供符合其興趣的內容和廣告。',
        description3:
          '公司也可採集不識別個人的統計資訊。此外，公司採集的Cookie資訊和其他方採集的Cookie資訊也可在第三方訪問分析工具平台上由雙方查看。'
      }
    },
    policy5: {
      title: '匿名處理資訊的處理',
      creation: {
        title: '匿名處理資訊的建立',
        description1:
          '公司在建立匿名處理資訊時採取以下措施。匿名處理資訊是指根據法律要求以無法識別特定個人的方式處理個人資料而獲得的個人相關資訊，使得原個人資料無法恢復。',
        description2:
          '① 按照法律規定的標準進行適當處理 ② 按照法律規定的標準實施安全管理措施以防止刪除的資訊和處理方法相關資訊的洩露 ③ 公開包含在建立的匿名處理資訊中的個人相關資訊的項目 ④ 不進行識別用於建立匿名處理資訊的個人資料所涉原人的行為'
      },
      provision: {
        title: '匿名處理資訊的提供',
        description:
          '當向第三方提供匿名處理資訊時，公司公開包含在匿名處理資訊中的個人相關資訊的項目和提供方式，並向接收者明示所提供的資訊是匿名處理資訊。'
      },
      disclosure: {
        title: '關於匿名處理資訊的公開',
        creationSubtitle: '匿名處理資訊的建立',
        creationDescription:
          '關於公司持有的以下使用者個人資料，公司在採取適當措施防止識別特定個人且確保原個人資料無法恢復的基礎上，持續建立匿名處理資訊。',
        itemsTitle: '包含在匿名處理資訊中的個人相關資訊的項目',
        itemsDescription:
          '平台服務提供相關採集的資訊：購買日期、參與日期、憑證語言、銷售金額範圍、參與者數量、預訂狀態(已確認或已取消)、供應商位置和地區資訊、旅行社位置國家。',
        thirdPartyTitle: '匿名處理資訊的第三方提供',
        thirdPartyDescription:
          '關於公司建立或持有的匿名處理資訊，公司在明示該資訊是匿名處理資訊的基礎上持續向第三方提供。',
        provisionMethod:
          '透過電子通信手段(電子郵件、伺服器上傳、API整合等)或物理媒體(如DVD)傳送密碼保護的電子文件。'
      }
    },
    policy6: {
      title: '個人數據的安全管理措施',
      description1:
        '公司採取組織、技術和物理安全管理措施以防止個人數據的洩露、盜用、濫用、未授權訪問、竄改和破壞。公司存儲個人數據的伺服器訪問僅限於擁有ID和密碼訪問權限的授權員工，其中某些個人數據的訪問權限僅授予數據管理所必需的最少員工。',
      description2:
        '此外，包含信用卡資訊的個人數據存儲在分散於多個數據中心的安全環境中。公司對與預訂交易相關的所有頁面使用安全套接層(SSL)加密。使用SSL相容瀏覽器可維護透過網際網路傳輸的個人數據和信用卡資訊的機密性。',
      description3:
        '處理使用者個人數據的公司員工在離開終端時使用密碼保護的螢幕保護程式。',
      description4:
        '此外，公司對某些部門每月進行一次、公司範圍內每年至少進行兩次關於個人資料重要性等的教育培訓。公司還保留這些培訓的記錄。'
    },
    policy7: {
      title: '關於個人數據處理的使用者權利',
      description:
        '根據2016年4月27日的歐盟通用數據保護條例(GDPR) 2016/679，使用者在個人數據處理方面具有以下權利：',
      right1: '訪問權',
      right2: '更正權',
      right3: '刪除權(被遺忘權)和限制處理權',
      right4: '數據可攜性權',
      right5: '異議權',
      right6: '不受基於分析的自動化決策約束的權利。'
    },
    policy8: {
      title: '關於公開、更正、中止使用等請求',
      description1:
        '公司透過下文第11節所述的聯繫方式對使用者關於持有個人數據的使用目的通知請求、公開請求、更正/增加/刪除請求、使用中止/刪除請求以及第三方提供中止請求(以下統稱"公開等請求")進行對應。',
      description2:
        '此外，公司透過使用者的賬戶頁面對使用者更改和確認會員資訊以及中止電子郵件雜誌配送等的請求進行對應。'
    },
    policy9: {
      title: '關於外部鏈接',
      description:
        'LINKTIVITY主頁包含指向其他網站的鏈接。本隱私政策僅適用於透過LINKTIVITY主頁採集的資訊，公司對其他網站的隱私政策或內容不承擔責任。使用者應閱讀所鏈接網站的隱私政策並確認其個人資料如何被處理。'
    },
    policy10: {
      title: '隱私政策的更改',
      description:
        '公司在LINKTIVITY主頁上發佈本隱私政策，使使用者能夠始終了解公司採集什麼個人資料、出於什麼目的採集以及如何使用。隱私政策的任何更改也會在LINKTIVITY主頁上發佈並向使用者公開。'
    },
    policy11: {
      title: '聯繫方式',
      description1:
        '關於公司隱私政策、公司個人資料保護措施、採集和使用使用者個人資料或提出公開等請求的任何問題，請使用下面的聯繫表。代表將在5個工作日內回覆。',
      company: 'Linktivity Inc.',
      address: '日本東京都千代田區內幸町2-1-6 日比谷公園前19樓',
      dpoContact: '數據保護官聯繫方式: dpo@linktivity.co.jp'
    },
    contentLabels: {
      acquisitionOfPersonalInfo: '採集的個人資料',
      specificPurpose: '具體的使用目的',
      legalBasis: '法律依據：',
      provisionMethod: '提供方式'
    }
  },
  terms: {
    title: 'LINKTIVITY利用規約',
    lastUpdated: '最終更新日 2020年05月01日',
    intro: {
      company: 'リンクティビティ株式会社（以下、「当社」といいます）は、',
      serviceDesc:
        'のサービスのご利用に関して、以下のとおりLINKTIVITY利用規約（以下、「本規約」といいます）を定めています。',
      agreement:
        'LINKTIVITYをご利用いただいた場合は、本規約に同意したものとみなしますので、LINKTIVITYのサービスをご利用いただきます際には、必ず本規約をお読みください。なお、本規約は、必要に応じ変更することがございますので、ご利用の際には最新の内容をご参照ください。',
      privacyNote: '＊個人情報の取り扱いについては、',
      privacyLinkText: '「個人情報保護方針」',
      privacyNoteSuffix: 'をお読みください。'
    },
    article1: {
      title: '第一条 規約の目的',
      content:
        '本規約は当社が運営する商品・サービス等の場貸し（プラットフォーム）販売サイト「LINKTIVITY」のサービス利用者に適用するものです。本サービスの利用者は、あらかじめ本規約に同意した上で、本サービスを利用するものとします。また、本規約は予告なく変更することがあります。'
    },
    article2: {
      title: '第二条 会員登録',
      items: [
        '「会員」とは、本規約を承認の上、本規約に基づき本サービスの提供を受けるために当社の指定する会員登録手続を完了し、当社が会員として承認した個人とします。ただし、承認後でも、当社が会員として不適当と判断した場合には承認の取り消しを行うことがあります。',
        '会員登録の際の登録情報に関して、いかなる虚偽の申告も認めないものとします。本人、登録情報（氏名、メールアドレス等）、パスワードは、それぞれ一つずつのみ対応するものとし、同一人物による複数の会員としての登録は認めないものとします。',
        '登録情報に変更が生じた場合は、会員は速やかに所定の変更手続きを行うものとします。'
      ]
    },
    article3: {
      title: '第三条 商品提供者が提供する情報',
      content:
        '当社は、LINKTIVITYにおいて、商品提供者が提供する内容、料金、購入可能日時、取消規定（キャンセルポリシー）等購入に必要な情報(以下、「購入関連情報」といいます)、および商品提供者に関する情報を会員に提供しますが、購入関連情報は、商品提供者の責任において提供されるものであり、当社が故意または過失による情報の非伝達のため発生したものを除き、当社は情報の内容については一切責任を負うものではありません。'
    },
    article4: {
      title: '第四条 契約成立',
      content:
        'LINKTIVITYのプラットフォームでは会員が購入する商品、サービス等の提供に関する契約は、会員と商品提供者との間で直接締結されます。LINKTIVITYにおける商品、サービス等の掲載は、商品提供者への申し込みを行うためのものであり、当社はその申し込みを当該商品提供者に代わって自由に承認または却下できます。本利用規約は、会員によるLINKTIVITYサービスの使用を規定するものであり、商品提供者への購入申し込みを行うためにLINKTIVITYを使用する場合も含みます ただし、会員が予約する商品・サービス等の提供は、LINKTIVITYに表示される契約条件、予約手続中に提示される情報、およびプ商品・サービス等の提供に関する法的な契約の締結先である商品提供者が定める契約条件に従うものとします。'
    },
    article5: {
      title: '第五条 代金のお支払',
      content: [
        'LINKTIVITYは商品提供者の代金回収代理業者として、会員のお支払い情報を取得し、支払いを処理します。会員は、商品・サービス等の購入時に当社へクレジットカードまたは当社が提供する決済手段にて代金を支払うものとします。外貨表記ので、当社が日本円でクレジットカード決済額または当社が提供する決済手段の請求金額を決定する場合は、当社が定めるレートにて日本円に換算することとします。',
        '但し、一部については、ページで指定された次のいずれかの方法で支払うものとします。'
      ]
    },
    article6: {
      title: '第六条 商品提供者が提供する商品・サービスの内容・品質',
      content:
        '当社は、商品提供者が提供する商品・サービスの内容・品質については一切責任を負うものではなく、会員と商品提供者との間で生じるトラブル、紛争もしくは苦情、会員が被る損害については、会員が商品提供者との間で解決するものとし、当社はこれらにつき何ら責任を負うものではありません。'
    },
    article7: {
      title: '第七条 利用環境',
      items: [
        '会員は、LINKTIVITYの利用に際して自己の費用と責任において、商品・サービス等の購入に必要な通信機器・ソフトウェア・通信手段等必要なものの全てを用意するものとします。',
        '会員は、LINKTIVITYの利用に際して自己の費用と責任において、商品・サービス等の利用に必要なインターネットに接続可能なスマートフォン・ソフトウェア・通信手段等必要なものの全てを用意するものとします。'
      ]
    },
    article8: {
      title: '第八条 会員の自己都合による購入の取消、取消料',
      items: [
        '会員の自己都合で購入を取消す場合の取消料は、該当商品提供者が定める取消規約（キャンセルポリシー）に則ります。',
        '当社は代金支払時と代金返金時の為替差損益については一切責任を負うものではありません。',
        '購入の取消は、原則、LINKTIVITYのマイページより行うものとします。但し、利用日直前で、商品提供者に直接電話で連絡がとれ、かつ商品提供者が購入の取消を受付けた場合は、後日、マイページよりLINKTIVITYへ、その旨連絡することにより取消手続きは完了するものとします。'
      ]
    },
    article9: {
      title: '第九条 商品提供者による取消、返金',
      content:
        '商品・サービス等の内容変更、中止に伴う会員への告知は商品提供者が行い、当社は商品・サービス等の変更、中止に伴なう責任は一切負いません。ただし、当社は商品提供者の決定・依頼に基づき販売した商品・サービス等の内容の変更や中止による商品・サービス等の払い戻し業務を代行する場合があります。'
    },
    article10: {
      title: '第十条 パスワードの管理',
      items: [
        '会員は、パスワードの管理責任を負うものとします。',
        '会員は、メールアドレス、パスワードを第三者に利用させたり、貸与、譲渡、名義変更、売買、質入等を行うことはできないものとします。',
        '会員のパスワードの管理不十分、使用上の過誤、第三者の使用等による損害の責任は、会員が負うものとし、当社は一切責任を負いません。'
      ]
    },
    article11: {
      title: '第十一条 会員登録情報の取扱い',
      items: [
        '会員登録の際に会員が登録した個人情報（以下、「登録情報」といいます）は、当社の個人情報保護方針に従い、当社が保有、管理するものとします。',
        {
          text: '当社は、登録情報のうち、特定の個人の識別が可能な情報（以下「個人情報」という。）を、第三者に開示しないものとします。ただし、以下の場合を除きます。',
          subItems: [
            '情報開示についてお客様の同意がある場合',
            '個人情報保護のための守秘義務契約を結んだ業務委託先に対しサービスを履行するために必要な個人情報を提供する場合',
            'サービス向上目的で個人情報を集計および分析し、個人を識別または特定できない状態で第三者に開示または提供する場合',
            '裁判所の発する令状その他裁判所の判断に従い開示する場合'
          ],
          note: 'なお、当社が取得した個人情報に関する、利用目的その他取り扱いについての詳細は「個人情報保護方針」をお読みください。'
        }
      ]
    },
    article12: {
      title: '第十二条 会員の禁止事項',
      intro:
        '会員は、LINKTIVITYを利用する際に、以下の行為またはそのおそれのある行為を行ってはならないものとします。',
      items: [
        '本規約に違反する行為',
        '公序良俗または法令に違反する行為',
        '当社、他の会員または第三者の著作権、肖像権、その他知的所有権を侵害する行為',
        '他の会員または第三者を誹謗・中傷する行為',
        '他の会員または第三者に不利益を与える行為',
        '当社の事業あるいは当社の提供するサービスの運営を妨害する行為',
        '営利を目的とする行為',
        '会員として得た権利を、当社の事前の同意を得ることなく第三者に譲渡および貸与する行為',
        'その他、当社が不適当と判断する行為'
      ]
    },
    article13: {
      title: '第十三条 会員発信情報の削除又は修正',
      intro:
        '当社は、会員が送信した情報のうち、以下のいずれかに該当するまたはそのおそれがあるものを、会員の承諾なく、全部または一部を削除し、またはこれに対し当社が必要と判断する修正を行うことができるものとします。',
      items: [
        '本規約の「会員の禁止事項」のいずれかの事項に該当すると当社が判断するもの',
        '事実に明らかに反すると当社が判断するもの',
        'その他当社が不適当と判断するもの'
      ]
    },
    article14: {
      title: '第十四条 会員資格の抹消',
      intro:
        '会員が以下の事由のいずれかに該当する場合、当社は会員に事前の通知することなく、また会員に対して何らの責任を負うことなく、会員資格を抹消することができるものとします',
      items: [
        '本規約の「会員の禁止事項」のいずれかの事項に該当する行為を行った場合',
        'その他、本規約のいずれかに違反した場合。',
        'その他、会員として不適格と当社が判断した場合'
      ]
    },
    article15: {
      title: '第十五条 サービスの変更・中断・中止',
      items: [
        '当社は、会員に事前に通知することなく、サービス内容を変更、中断または中止する場合があります。',
        '本サービス内容の変更または中断に伴い、会員に不利益または損害が発生した場合であっても、当社はその責任を負わないものとします。',
        '当社は、会員に対して１ヶ月前に通知することにより、サービスの提供を中止することができるものとします。'
      ]
    },
    article16: {
      title: '第十六条 著作権および財産権',
      content:
        'LINKTIVITYに表示されるすべての内容に関する著作権および財産権は、当社および当社にそれらの内容を提供している、商品提供者、提携先、広告主に帰属しています。利用者および会員は、当社、商品提供者、提携先、広告主の事前の文書による承諾を受けた場合を除いて、それらの内容を複製、公開、譲渡、貸与、翻訳、転載、送信、使用許諾、再利用しないことなどに同意するものとします。また、利用者および会員がこれらの行為によって得た利益相当額を当社が請求できる権利を有していることとします。'
    },
    article17: {
      title: '第十七条 免責・責任制限',
      items: [
        '当社は、会員と商品提供者との間で生じた損害、会員が本規約に違反して生じた損害、商品・サービス等のチケットへの引き換えにおいて当社の責に帰さない事由により発生した損害については、一切の責任を負わないものとします。',
        '商品提供者は、当社とは独立した契約主体であり、商品提供者による、いかなる行為、過失、怠慢、代理行為、保証や、商品・サービス等の参加に関連する会員の負傷、死亡、所有物の損傷・遺失テロリズムに帰する損害、その他あらゆる損害等について、当社は一切責任を負うものではありません。',
        '当社は、当社の直接の管理範囲を超えた原因により生じた、商品・サービス等の遅延、キャンセル、重複購入、ストライキに対する責任を負わないものとします。また、政府当局や裁判所令状等による内容変更、キャンセル、遅延、追加費用の発生等についても応じる義務を負いません。',
        '当社は、当社に故意または過失がある場合においても、会員に対し、本サービスの提供に関連して会員に発生した現実かつ直接の通常損害以外の損害を負担しません。'
      ]
    },
    article18: {
      title: '第十八条 本規約の変更',
      content:
        '本規約の内容について、当社は必要に応じ変更できるものとします。本規約を変更した場合は、本画面上の変更をもってその変更が終了したものとし、都度、会員への通知は行わないものとします。'
    },
    article19: {
      title: '第十九条 合意管轄',
      content:
        '本規約に関する一切の紛争については、東京地方裁判所を第一審の専属管轄裁判所とします。'
    },
    article20: {
      title: '第二十条 協議',
      content:
        '本規約に定めのない事項又は本規約に関する疑義が生じた場合には、関係当事者間にて誠意をもって協議し、円満に解決するよう努めるものとします。'
    }
  },
  law: {
    title: '特定商取引法に基づく表記',
    serviceName: '服務名稱',
    companyName: '銷售業者',
    representative: '代表者姓名',
    address: '所在地',
    contact: '諮詢處',
    paymentTerms: '付款方式及付款時間',
    deliverySchedule: '商品交付時間',
    sellingPrice: '商品等的銷售價格',
    shippingFee: '運費',
    additionalFee: '銷售價格・運費等以外的必要費用',
    salesRestrictions: '銷售期間・銷售數量的限制',
    returnsAndCancellations: '退貨・取消',
    otherConditions: '其他條件'
  },
  requireForm: {
    lastName: '姓氏',
    firstName: '名字',
    participantInfo: '用戶資訊',
    requiredBookingInfo: '所需信息',
    BookingFieldMethod: {
      PER_PARTICIPANT: '每位參加者',
      PER_BOOKING: '每次預訂'
    },
    bookingFields: {
      participantEmailAddress: '參加者郵箱',
      hotelName: '住宿地點名稱',
      hotelAddress: '住宿地點地址',
      hotelReservationLastName: '住宿代表人 姓',
      hotelReservationFirstName: '住宿代表人 名',
      hotelReservationName: '住宿代表人',
      hotelTel: '住宿地點電話',
      arrivalDate: '到達日',
      arrivalTime: '抵達時間',
      arrivalFlightNumber: '抵達航班號',
      departureDate: '出發日期',
      departureTime: '出發時間',
      departureFlightNumber: '出發航班號',
      destinationEmail: '當地聯絡方式（郵箱）',
      destinationTel: '當地聯絡方式（電話）',
      gender: '性別',
      agentChannelRegion: '旅行社所在國家・地區',
      agentChannelLanguage: '旅行社語言',
      participantResidentRegion: '參加者居住國家・地區',
      participantLanguage: '參加者語言',
      passengersQuantity: '乘車人數',
      prescriptionMaskQuantityFree: '含度數面鏡所需數量 ※免費',
      prescriptionMaskQuantityPaid: '含度數面鏡所需數量 ※現場付費',
      preferredStartTime: '希望的開始時間',
      preferredPickUpLocation: '迎接或乘車地點',
      preferredDropOffLocation: '送返或下車地點',
      participantsQuantity: '參加人數',
      luggageQuantity: '行李箱合計數量',
      childrenWithoutSeatQuantity: '不佔位的嬰幼兒人數',
      childSeatQuantityPaid: '兒童安全座椅所需數量 ※現場付費',
      childSeatQuantityFree: '兒童安全座椅所需數量 ※免費',
      guideJa: '是否需要日文導遊',
      driverJa: '是否需要日文司機',
      guideEn: '是否需要英文導遊',
      driverEn: '是否需要英文司機',
      guideZh: '是否需要中文導遊',
      driverZh: '是否需要中文司機',
      guideKo: '是否需要韓文導遊',
      driverKo: '是否需要韓文司機',
      preferredGuideLanguageCode: '希望的導遊服務語言',
      preferredDriverLanguageCode: '希望的司機服務語言',
      passportNationality: '國籍',
      passportFirstName: '參加者名字（請填寫與護照相符的英文拼音）',
      passportLastName: '參加者姓氏（請填寫與護照相符的英文拼音）',
      dateOfBirth: '出生年月日',
      age: '年齡',
      passportNumber: '護照號碼',
      eyesight: '視力',
      weightKg: '體重（kg）',
      heightCm: '身高（cm）',
      shoeSizeCm: '鞋碼（cm）',
      weightLbs: '體重（lbs）',
      heightIn: '身高（ft/in）',
      clothesSize: '服裝尺寸',
      vegetarianMeals: '是否需要素食',
      divingExperienceTimes: '潛水經驗次數',
      rentalEquipmentsFree: '是否需要租借器材 ※免費',
      rentalEquipmentsPayLocally: '是否需要租借器材 ※現場付費',
      male: '男',
      female: '女',
      other: '其他',
      yes: '是',
      no: '否'
    }
  },
  components: {
    selectOption: {
      title: '附加商品',
      quantity: '數量: {{quantity}}',
      addCart: '加入購物車',
      planSelect: '選擇方案',
      dateSelect: '選擇日期',
      dateLabel: '日期',
      timeSelect: '選擇時間',
      quantitySelect: '選擇數量',
      quantitySelectLabel: '數量',
      soldOut: '售罄',
      total: '合計',
      viewDetail: '查看詳情',
      unitRatioNotCounted: '※此附加不計入合計數量',
      unitRatioCounted: '※每 1 個計為 {{quantity}} 人份'
    },
    planDetailDrawer: {
      title: '方案詳情',
      planContent: '方案內容',
      meetingPlace: '集合地點',
      cancellationPolicy: '取消政策',
      capacity: '可容納人數',
      maxCapacity: '最大可容納人數',
      minCapacity: '最小可容納人數',
      bookingAcceptance: '可預訂期間',
      bookingDeadline: '預訂截止日期',
      voucherExpirationPeriod: '憑證有效期',
      inclusion: '包含項目',
      participationLocations: '參加地點',
      participationLocationKind: {
        MAP_OF_MEETING_POINT: '集合地點地圖',
        NOTE_OF_LOCATION_AND_DIRECTION: '地點及路線說明',
        LANDMARKS_TO_MEETING_POINT: '集合地點地標',
        PICK_UP_CAR: '接送車輛',
        PICK_UP_GUIDE: '接送導遊',
        ITINERARY: '行程',
        PARKING: '停車場資訊'
      },
      restrictions: '參加限制',
      requirements: '參加前・參加時必要事項',
      attireItems: '參加時必要的服裝・物品',
      otherInfo: '備註・其他'
    },
    payment: {
      ticket: '門票',
      option: '附加商品',
      total: '合計（含稅）',
      details: '詳情',
      submit: '去下單'
    },
    bookInfo: {
      plan: '套餐',
      dateTime: '日期時間',
      validityPeriod: '有效期',
      ticket: '門票',
      option: '附加商品',
      discount: '折扣',
      total: '合計（含稅）'
    },
    coupon: {
      title: '優惠券',
      caption: '請輸入優惠券代碼',
      apply: '使用'
    },
    bookingDetailVoucher: {
      pdf: '打印用PDF',
      html: '憑證'
    },
    collapsibleCard: {
      stockStatus: {
        available: '銷售中',
        limited: '剩餘少量',
        soldOut: '售罄'
      }
    },
    unitCard: {
      minCapacityWarning: '最少購買數量為 {{quantity}} 件，請確認數量',
      maxCapacityReached: '已達到購買上限',
      optionQuantityLimitReached: '目前所選內容下無法新增此附加'
    }
  },
  bookingDetail: {
    title: '預訂詳情',
    meetingPoint: '入場位置指南',
    beforeTrip: '使用前確認事項',
    reservationInfo: '預訂資訊',
    redemption: '使用電子票',
    digitalTicketWaiting: '*訂單確認後，電子票將在此顯示',
    inclusion: '包含的物品',
    restrictions: '參加限制',
    requirements: '參加前及參加時須知事項',
    attireItems: '參加時所需服裝及攜帶物品',
    otherInfo: '備考・其他',
    cancelSuccess: '已成功取消訂單。',
    sendToEmailSuccess: '郵件發送成功，請檢查您的收件箱',
    sendToEmailError: '郵件發送失敗，請稍後重試'
  },
  bookResult: {
    pendingTitle: '正在確認支付',
    pendingMessage: '您的訂單尚未完成，請耐心等待處理完成。',
    successMessage:
      '感謝您的預訂。預訂憑證將立即發送到您註冊的電子郵件地址，請檢查您的收件箱。',
    failedMessage: '支付失敗，請重新預約。',
    timeoutMessage:
      '處理超時，請稍後再重新整理瀏覽器，您可查看是否有收到訂單通知信或自以下的訂單資訊畫面查看是否有訂購成功。',
    backToProduct: '返回商品頁'
  },
  booking: {
    title: '預訂資訊',
    bookingNumber: '預訂編號',
    viewDetail: '預訂資訊查看',
    toBooking: '再次預訂',
    bookingRange: {
      oneMonth: '1個月內的預訂',
      threeMonths: '3個月內的預訂',
      sixMonths: '半年內的預訂'
    },
    plan: '方案',
    participationTime: '參加日期時間',
    validityPeriod: '有效期',
    count: '數量',
    option: '附加商品',
    paidAmount: '付款金額',
    customerName: '預訂姓名',
    refundAmount: '退款金額',
    orderCompletionTime: '預訂時間',
    adultTicket: '成人',
    childTicket: '兒童',
    status: {
      BOOKING_STATUS_CONFIRMED: '預訂成功，已出票',
      BOOKING_STATUS_PENDING: '預訂中',
      BOOKING_STATUS_CANCEL_PENDING: '取消中',
      BOOKING_STATUS_CANCELED: '已取消',
      BOOKING_STATUS_USED: '已使用',
      BOOKING_STATUS_WITHDRAWN: '預約未成立',
      BOOKING_STATUS_APPLIED: '抽選申請已受理',
      BOOKING_STATUS_APPLIED_DECLINED: '抽選申請未受理',
      BOOKING_STATUS_DECLINED: '抽選申請未受理'
    }
  }
};
